import React from 'react';
import { integrationView as IntegrationView } from './integrationView';
import { cloneDeep } from 'lodash';
import APP from '../../modules';
import { fetch } from '../../modules/httpServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class IntegrationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabVal: 'Requirement Management',
      projName: '',
      jiraCheck: false,
      integrationTabVal: [],
      projOptions: [],
      isEdit: false,
      requirementData: [],
      requirementOption: [
        { id: 'jira', displayLabel: 'Jira', value: 'jira' },
        {
          id: 'azureDevops',
          displayLabel: 'Azure Devops',
          value: 'Azure Devops'
        }
      ],
      defectOption: [
        { id: 'jira', displayLabel: 'Jira', value: 'jira' },
        { id: 'bugzilla', displayLabel: 'Bugzilla', value: 'bugzilla' },
        {
          id: 'azureDevops',
          displayLabel: 'Azure Devops',
          value: 'Azure Devops'
        }
      ],
      cicdOption: [
        { id: 'jenkins', displayLabel: 'Jenkins', value: 'jenkins' },
        {
          id: 'azureDevops',
          displayLabel: 'Azure Devops',
          value: 'Azure Devops'
        }
      ],
      dbOption: [
        { id: 'mysql', displayLabel: 'Mysql', value: 'mysql' },
        { id: 'sql', displayLabel: 'Sql', value: 'sql' },
        { id: 'mongodb', displayLabel: 'Mongodb', value: 'mongodb' },
        { id: 'postgres', displayLabel: 'Postgres', value: 'postgres' },
        { id: 'oracle', displayLabel: 'Oracle', value: 'oracle' }
      ],
      selected: {
        platform: '',
        url: '',
        userName: '',
        password: '',
        ipAdd: '',
        dbName: '',
        projectName: ''
      }
    };
  }

  componentDidMount() {}

  onSelectChange = ({ id, val }) => {
    const _state = cloneDeep(this.state);
    _state.selected[id] = val;
    if (val === 'jira') {
      _state.jiraCheck = true;
    } else {
      _state.jiraCheck = false;
    }
    this.setState(_state);
  };

  onSaveClick = (eve, name) => {
    const _state = cloneDeep(this.state);
    let nameValuePairs;
    if (name === 'DataBase') {
      nameValuePairs = [
        { name: 'dbName', value: _state.selected.dbName },
        { name: 'ipAdd', value: _state.selected.ipAdd },
        { name: 'userName', value: _state.selected.userName },
        { name: 'password', value: _state.selected.password }
      ];
    } else if (name === 'Defect Management') {
      nameValuePairs = [
        { name: 'platform', value: _state.selected.platform },
        { name: 'url', value: _state.selected.url },
        { name: 'userName', value: _state.selected.userName },
        { name: 'password', value: _state.selected.password },
        { name: 'projectName', value: _state.selected.projectName }
      ];
    } else {
      nameValuePairs = [
        { name: 'platform', value: _state.selected.platform },
        { name: 'url', value: _state.selected.url },
        { name: 'userName', value: _state.selected.userName },
        { name: 'password', value: _state.selected.password }
      ];
    }
    const RequestBody = {
      integrationConfigName: name,
      projectId: _state.projName,
      nameValuePairs
    };
    if (_state.isEdit) {
      fetch.put({
        url: APP.Constants.SERVICE_URLS.INTEGRATION_API,
        requestBody: {
          integrationConfigId: _state.integrationTabVal[0].integrationConfigId,
          ...RequestBody
        },
        callbackHandler: this.successHandler
      });
    } else {
      fetch.post({
        url: APP.Constants.SERVICE_URLS.INTEGRATION_API,
        requestBody: RequestBody,
        callbackHandler: this.successHandler
      });
    }
  };

  successHandler = (res) => {
    const _state = cloneDeep(this.state);
    const { status } = res;
    if (APP.Constants.SUCCESS === status) {
      if (_state.isEdit) {
        toast.success('Successfuly Updated!', {
          position: toast.POSITION.TOP_CENTER
        });
      } else {
        toast.success('Successfuly Saved!', {
          position: toast.POSITION.TOP_CENTER
        });
      }
      fetch.get({
        url:
          APP.Constants.SERVICE_URLS.PROJECTS.PROJECT_INTEGRATION +
          _state.projName,
        callbackHandler: (res, name) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            const data = payload.filter(
              (item) => item.integrationConfigName === name
            );
            const nameValuePairsData = data[0]?.nameValuePairs.map((val) => {
              _state.selected[val.name] = val.value;
            });
            _state.requirementData = payload;
            _state.isEdit = true;
            this.setState(_state);
          } else {
            this.setState({ requirementData: [] });
          }
        }
      });
    } else {
      this.setState({});
    }
  };

  onChange = ({ id, value }) => {
    const _state = cloneDeep(this.state);
    if (typeof id === 'undefined') {
      _state.projName = value;
      fetch.get({
        url: APP.Constants.SERVICE_URLS.PROJECTS.PROJECT_INTEGRATION + value,
        callbackHandler: (res) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            const data = payload.filter(
              (item) => item.integrationConfigName === _state.tabVal
            );
            data.length ? (_state.isEdit = true) : (_state.isEdit = false);
            _state.integrationTabVal = data;
            const nameValuePairsData = data[0]?.nameValuePairs.map((val) => {
              _state.selected[val.name] = val.value;
            });
            _state.requirementData = payload;
            this.setState(_state);
          } else {
            this.setState({ requirementData: [] });
          }
        }
      });
    } else {
      _state.selected[id] = value;
    }
    this.setState(_state);
  };

  resetValues = (val) => {
    const _state = cloneDeep(this.state);
    const data = _state.requirementData?.filter(
      (item) => item.integrationConfigName === val
    );
    if (data.length) {
      _state.isEdit = true;
      _state.integrationTabVal = data;
      const nameValuePairsData = data[0]?.nameValuePairs.map((val) => {
        _state.selected[val.name] = val.value;
      });
    } else {
      _state.selected.platform = '';
      _state.selected.url = '';
      _state.selected.userName = '';
      _state.selected.password = '';
      _state.selected.ipAdd = '';
      _state.selected.dbName = '';
      _state.tabVal = val;
      _state.jiraCheck = false;
      _state.isEdit = false;
    }
    this.setState(_state);
  };

  render() {
    return (
      <IntegrationView
        {...{
          ...this.state,
          onChange: this.onChange,
          resetValues: this.resetValues,
          onSelectChange: this.onSelectChange,
          onSaveClick: this.onSaveClick
        }}
      />
    );
  }
}

export default IntegrationComponent;
